import { useRef, useState } from "react";

const useInput = (validacion) => {
    const divInput = useRef();
    const [value, setValue] = useState('');
    const [isTouched, setIsTouched] = useState(false);
    const [userChange, setUserChange] = useState(false);

    const isValid = validacion(value);

    const setInputValue = (value) => {
        setValue(value);
    }

    const valueChangeHandler = (event) => {
        if(!userChange)
            setUserChange(true);
        setValue(event.target.value);
    }

    const inputBlurHandler = () => {
        setIsTouched(true);
    }

    const resetInput = () => {
        setValue('');
        setIsTouched(false);
        setUserChange(false);
    }

    const headerOffset = 56; // Tamaño del header en px
    const scrollToDiv = () => {
        let pos = divInput.current.getBoundingClientRect().top;
        let offset = pos + window.pageYOffset - headerOffset - parseInt(window.innerHeight/10);

        window.scrollTo({
            top: offset,
            behavior: "smooth"
        });
    }

    return {
        value,
        isValid,
        isTouched,
        userChange,
        divInput,
        setInputValue,
        valueChangeHandler,
        inputBlurHandler,
        resetInput,
        scrollToDiv,
    };
};

export default useInput;